import { useCallback, useEffect, useRef } from 'react'
import { usePage } from '@inertiajs/react'
import BwiSearch from '@/icons/bwi/search.svg'
import { searchTypes } from './refinement-list'
import { cx } from '@/utils/strings'
import { getLocale, localizedPath } from '@/utils/locale'
import colors from '@/constants/colors'

type NavIconProps = {
  backgroundColor?: string
  children?: React.ReactNode
  onClick?: () => void
  navigateToSearch?: boolean
}

export default function NavIcon({ children, backgroundColor, onClick, navigateToSearch = true }: NavIconProps) {
  const ref = useRef<HTMLButtonElement>(null)
  const page = usePage()
  const pathname = page.url
  const gotoSearch = useCallback(() => {
    const type = searchTypes.find((thisType) => pathname.startsWith(`/${thisType}/`))
    const locale = getLocale(pathname)
    const url = type
      ? localizedPath(`/search/?${new URLSearchParams({ type })}`, locale)
      : localizedPath('/search/', locale)
    window.location.assign(url)
  }, [pathname])

  const handleClick = () => {
    if (navigateToSearch) gotoSearch()
    onClick?.()
  }

  useEffect(() => {
    if (ref.current)
      ref.current.setAttribute(
        'title',
        `${'Search'} (${
          typeof navigator !== 'undefined' && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? '⌘' : 'Ctrl'
        } + K)`
      )
    const onKeyDown = (event: KeyboardEvent) => {
      if (event?.key?.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        handleClick()
      } else if (event?.key === 'Escape' && pathname.endsWith('/search/')) {
        event.preventDefault()
        // navigate(-1)
      }
    }

    window.addEventListener('keydown', onKeyDown)

    return (): void => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [navigateToSearch])

  return (
    <button
      type="button"
      ref={ref}
      onClick={handleClick}
      className={cx(
        "flex items-center justify-center",
        backgroundColor === colors.white && 'hover:text-indigoBlue',
        backgroundColor !== colors.white && 'hover:text-secondary-200',
        'dark:hover:text-primaryBlue',
      )}
    >
      <BwiSearch
        className={cx(
          `w-7 h-7 p-1 lg:w-12 lg:h-12 lg:p-3`,
          
        )}
      />
      {children}
    </button>
  )
}
